import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classes from './Children.module.scss';
import { PlusIcon } from '@icons';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';
import { childrenSelector } from '@models/subscription/selectors';
import { getMaskedPhone } from '@utils/masks';
import ChildPhoneCard from '@shared/ChildPhoneCard/ChildPhoneCard';
import { triggerMetricsEvent } from '@metrics';
import { useNavigate } from 'react-router';
import { Page } from '@const';
const Children = ({ isAddAvailable, className }) => {
    const children = useSelector(childrenSelector);
    const navigate = useNavigate();
    const child = children.length ? children[0] : null;
    const name = child?.name;
    const title = name ? `Ребёнок: ${name}` : 'Ребёнок';
    const phone = getMaskedPhone(child?.msisdn || '');
    const handleAddClick = () => {
        triggerMetricsEvent({ element: 'addChildButton' });
        navigate(Page.AddChild);
    };
    if (isAddAvailable) {
        return (_jsxs("button", { className: classNames(classes.child, classes.addButton, className), onClick: handleAddClick, children: [_jsx(PlusIcon, { containerClasses: classes.icon }), _jsxs("span", { className: classes.text, children: ["\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0420\u0435\u0431\u0451\u043D\u043A\u0430", _jsx("span", { children: "\u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0432" })] })] }));
    }
    if (child) {
        return (_jsx(ChildPhoneCard, { title: title, phone: phone, className: classNames(classes.child, className), titleClasses: classes.title, phoneClasses: classes.phone, avatar: child?.picture }));
    }
    return null;
};
export default Children;
